import { Icon } from "@zapier/design-system";
import { Tooltip, Button } from "@zapier/design-system-beta";
import { isTemplateTableId } from "@zapier/canvas-state";

import { useEmitUserInteractionEvents } from "../../hooks/useEmitUserInteractionEvents";
import { getTablesOrigin } from "../../utils/urls";

type Props = { tableId: string };

export function TableLink({ tableId }: Props) {
  const { emitEventOnAssetOpen } = useEmitUserInteractionEvents();

  // Don't show link if the table id is a template id
  if (isTemplateTableId(tableId)) {
    return null;
  }

  const tableLink = `//${getTablesOrigin()}/app/tables/t/${tableId}`;

  return (
    <Tooltip placement="top" content="Open table">
      <Tooltip.FocusableTrigger>
        <Button
          size="small"
          onPress={async () => {
            emitEventOnAssetOpen({
              asset: "Table",
              location: "node",
            });
            window.open(tableLink, "_blank");
          }}
        >
          <Icon name="arrowOffsite" size={20} color="BackgroundDefault" />
          Edit
        </Button>
      </Tooltip.FocusableTrigger>
    </Tooltip>
  );
}
